import { render, staticRenderFns } from "./PelatihanNarasumberReport.vue?vue&type=template&id=01aa56ce"
import script from "./PelatihanNarasumberReport.vue?vue&type=script&lang=js"
export * from "./PelatihanNarasumberReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports